import './component.css'
import './controls/controls.css'
import DoctorCard from "./DoctorCard";
import ReadMore from './ReadMore'
import Tab from './Tabs'
import CustomCarousel from "./carousel/CustomCarousel";
import CustomSelect from "./controls/CustomSelect";
import Footer from "../../layouts/Footer";
import ServiceCard from "./sevices/ServiceCard";
import SpecialityCard from "./sevices/SpecialityCard";
import Header from '../../layouts/Header';
import ButtonPrimary from './controls/ButtonPrimary';
import CommonBanner from './banner/CommonBanner';
import CommonBannerDoctor from './banner/CommonBannerDoctor';
import NetworkCard from './sevices/NetworkCard';
import CommonSlider from './carousel/CommonSlider';



export {DoctorCard, ReadMore,Tab,CustomSelect,ServiceCard,SpecialityCard,CustomCarousel,Header,Footer,ButtonPrimary,CommonBanner,NetworkCard,CommonSlider,CommonBannerDoctor}